/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Nav_StoryInputs */

const en_fw_nav_story = /** @type {(inputs: Fw_Nav_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story`)
};

const zh_fw_nav_story = /** @type {(inputs: Fw_Nav_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`剧情`)
};

/**
* | output |
* | --- |
* | "Story" |
*
* @param {Fw_Nav_StoryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_nav_story = /** @type {((inputs?: Fw_Nav_StoryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Nav_StoryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_nav_story(inputs)
	return zh_fw_nav_story(inputs)
});
export { fw_nav_story as "fw.nav.story" }